import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable()
export class LicensingService {
  licenseData: any;
  constructor(public configService: ConfigService, public networkService: NetworkService) { }

  getLicenseInfoData() {
    return this.licenseData;
  }
  setLicenseInfoData(orderData) {
    this.licenseData = orderData;
  }

  // Get licensing List
  public getLicensingList(filters) {
    return this.networkService.postRequest(this.configService.getLicenseData(), filters);
  }

  // Get licensing Filters
  public getLicensingFilters() {
    return this.networkService.getRequest(this.configService.getLicenseFiltersData());
  }

  // Add Update Delete Grower License
  public addUpdateDeleteGrowerLicense(licenseList) {
    return this.networkService.postRequest(this.configService.addUpdateDeleteGrowerLicenseData(), licenseList);
  }

  // Get licensing Report
  public getLicensingReport(filters) {
    return this.networkService.postRequest(this.configService.getLicenseReport(), filters);
  }

  // Get licensing order detail
  public getLicensingOrderDetail(filters) {
    return this.networkService.postRequest(this.configService.getLicenseOrderDetail(), filters);
  }

  // Get licensing order detail
  public getGrowerGLN(gmk) {
    return this.networkService.getRequest(this.configService.getGrowerGLN() + '?gmk=' + gmk);
  }
}
